import { BindingEngine } from 'aurelia-framework';
import { Disposable } from 'framework/aurelia_tools/binding-helper';
import { DataMarker } from "support/map";
import { UserLocation } from 'model/users-locations';
import * as L from 'leaflet';
import { UserLocationDataMarkerControllerOptions } from './user-location-data-marker-controller-options';

export class UserLocationDataMarkerController {
  private isHighlightedSubscription: Disposable = null;
  private isDetailSubscription: Disposable = null;

  constructor(private bindingEngine: BindingEngine, public dataMarker: DataMarker<UserLocation>, private userLocationsMarkersGroup: L.MarkerClusterGroup, private options: UserLocationDataMarkerControllerOptions) {
  }

  attach() {
    this.isHighlightedSubscription = this.bindingEngine.propertyObserver(this.dataMarker.data, 'isHighlighted').subscribe((newValue) => this.isHighlightedChanged(newValue));
    this.isDetailSubscription = this.bindingEngine.propertyObserver(this.dataMarker.data, 'isDetail').subscribe((newValue) => this.isDetailChanged(newValue));
    this.ensureDetail();
  }

  unattach() {
    this.isHighlightedSubscription.dispose();
    this.isDetailSubscription.dispose();
  }

  isHighlightedChanged(newValue: boolean) {
    const markerOrGroup = this.userLocationsMarkersGroup.getVisibleParent(this.dataMarker);
    if (markerOrGroup != null) {
      if (newValue) {
        if (this.dataMarker === markerOrGroup)
          this.dataMarker.setIcon(this.options.highlightMarkerIcon);
      }
      else if (this.dataMarker === markerOrGroup)
        this.dataMarker.setIcon(this.options.getStandardMarkerIcon(this.dataMarker.data));
    }
  }

  isDetailChanged(newValue: boolean) {
    this.refreshDetail();
  }

  public refreshDetail() {
    const markerOrGroup = this.userLocationsMarkersGroup.getVisibleParent(this.dataMarker);
    if (markerOrGroup != null) {
      if (this.dataMarker.data.isDetail) {
        markerOrGroup.bindPopup(this.options.popupContent);
        markerOrGroup.openPopup();
      }
      else {
        markerOrGroup.closePopup();
        markerOrGroup.unbindPopup();
      }
    }
  }

  private ensureDetail() {
    if (this.dataMarker.data.isDetail) {
      const markerOrGroup = this.userLocationsMarkersGroup.getVisibleParent(this.dataMarker);
      if (markerOrGroup != null) {
        markerOrGroup.bindPopup(this.options.popupContent);
        markerOrGroup.openPopup();
      }
    }
  }
}
